import { Checkbox } from "@arcadeai/design-system/components/ui/atoms/checkbox";
import { Label } from "@arcadeai/design-system/components/ui/atoms/label";
import { useCallback } from "react";

type OAuthScopePickerProps = {
  scopesSupported: string[];
  selectedScopes: string[];
  onScopesChange: (scopes: string[]) => void;
  disabled?: boolean;
};

export const OAuthScopePicker = ({
  scopesSupported,
  selectedScopes,
  onScopesChange,
  disabled = false,
}: OAuthScopePickerProps) => {
  const handleToggle = useCallback(
    (scope: string, checked: boolean) => {
      if (checked) {
        onScopesChange([...selectedScopes, scope]);
      } else {
        onScopesChange(selectedScopes.filter((s) => s !== scope));
      }
    },
    [selectedScopes, onScopesChange]
  );

  if (scopesSupported.length === 0) {
    return null;
  }

  return (
    <div className="space-y-3">
      <div className="space-y-1">
        <p className="font-medium text-sm">Permissions</p>
        <p className="text-muted-foreground text-xs">
          Select the scopes to request during authorization.
        </p>
      </div>
      <div className="space-y-2 rounded-md border p-3">
        {scopesSupported.map((scope) => (
          <div className="flex items-center gap-2" key={scope}>
            <Checkbox
              checked={selectedScopes.includes(scope)}
              disabled={disabled}
              id={`scope-${scope}`}
              onCheckedChange={(checked) =>
                handleToggle(scope, checked === true)
              }
            />
            <Label
              className="cursor-pointer font-mono text-sm"
              htmlFor={`scope-${scope}`}
            >
              {scope}
            </Label>
          </div>
        ))}
      </div>
    </div>
  );
};
